import React from 'react'
import '../components/EnergyBan.css'
import SOLARPLANT from "../images/videos/VIDEOS/VID5.mp4";
export default function EnergyBan() {

  const handleWhatsApp = () => {
    const phone = "919597839564";
    const message = encodeURIComponent(
      "Hello RAD EnviroNex Team 👋\n\n" +
      "I am interested in conducting a professional *Energy Audit* for my organization/facility. " +
      "We are looking to optimize our energy consumption and identify efficiency opportunities.\n\n" +
      "Kindly share more details regarding your audit process and scheduling.\n\n" +
      "Looking forward to hearing from you!"
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };



  return (
    <>







      <section className="hero">
        {/* VIDEO */}
        <video
          className="hero-video"
          src={SOLARPLANT}
          autoPlay
          loop
          muted
          playsInline
        />

        {/* OVERLAY */}
        <div className="hero-overlay"></div>

        {/* CONTENT */}
        <div className="hero-content">
          <div className="title-box animate-glow">
            <h1>ENERGY AUDIT </h1>
            <p>Power Your Future with the Sun</p>

            <button className="quote-btn" onClick={handleWhatsApp}>
              Get Quote
            </button>
          </div>
        </div>
      </section>







    </>
  )
}
